import { newE2EPage } from "@stencil/core/testing";

describe("uic-pagination", () => {
    it("should log an error if required props are not set", async () => {
        const error = jest.spyOn(global.console, "error");
        const page = await newE2EPage({
            html: `<uic-pagination></uic-pagination>`
        });
        const el = await page.find("uic-pagination");
        expect(el).toHaveClass("hydrated");
        expect(error).toHaveBeenCalled();

        error.mockReset();
        error.mockRestore();
    });

    it("should by default display all pages if < 7", async () => {
        const error = jest.spyOn(global.console, "error");
        const page = await newE2EPage({
            html: `<uic-pagination total-pages="5"></uic-pagination>`
        });
        const el = await page.find("uic-pagination");
        await page.waitForChanges();

        expect(error).not.toHaveBeenCalled();
        expect(el).toMatchSnapshot();

        error.mockReset();
        error.mockRestore();
    });

    describe("with > 7 pages", () => {
        const error = jest.spyOn(global.console, "error");

        it("should by default display the first 5 pages if > 7", async () => {
            const page = await newE2EPage({
                html: `<uic-pagination total-pages="50"></uic-pagination>`
            });
            const el = await page.find("uic-pagination");
            await page.waitForChanges();

            expect(error).not.toHaveBeenCalled();
            expect(el).toMatchSnapshot();
        });

        it("should focus the input field when clicking on the ellipsis and change the page after 750ms", async () => {
            const page = await newE2EPage({
                html: `<uic-pagination total-pages="50"></uic-pagination>`
            });
            const el = await page.find("uic-pagination");
            await page.waitForChanges();

            const uicShow = await page.spyOnEvent("uicShow");

            const ellipsis = await page.find(".uic-pagination__page-button--ellipsis");
            await ellipsis.click();
            await page.waitForChanges();
            expect(uicShow).toHaveReceivedEvent();

            const popover = await page.find("uic-popover");
            expect(popover).toHaveAttribute("open");

            await page.keyboard.press("Backspace");
            await page.keyboard.press("2");
            await page.keyboard.press("0");

            await new Promise((r) => setTimeout(r, 750)); // wait for debounce
            await page.waitForChanges();

            const currentPage = await el.getProperty("page");
            expect(currentPage).toEqual(20);

            expect(popover).not.toHaveAttribute("open");

            expect(error).not.toHaveBeenCalled();
            // eslint-disable-next-line
            // This snapshot is always different on CI vs. local (because of different puppeteer versions) - so we disable it for now.
            // expect(el).toMatchSnapshot();
        });

        it("should change the page directly when pressing Enter in the input field", async () => {
            const page = await newE2EPage({
                html: `<uic-pagination total-pages="50"></uic-pagination>`
            });
            const el = await page.find("uic-pagination");
            await page.waitForChanges();

            const ellipsis = await page.find(".uic-pagination__page-button--ellipsis");
            await ellipsis.click();

            await page.keyboard.press("Backspace");
            await page.keyboard.press("2");
            await page.keyboard.press("0");
            await page.keyboard.press("Enter");

            await page.waitForChanges();

            const currentPage = await el.getProperty("page");
            expect(currentPage).toEqual(20);

            expect(error).not.toHaveBeenCalled();
        });

        it("should change the page directly when clicking the ellipsis again", async () => {
            const page = await newE2EPage({
                html: `<uic-pagination total-pages="50"></uic-pagination>`
            });
            const el = await page.find("uic-pagination");
            await page.waitForChanges();

            const ellipsis = await page.find(".uic-pagination__page-button--ellipsis");
            await ellipsis.click();

            await page.keyboard.press("Backspace");
            await page.keyboard.press("2");
            await page.keyboard.press("0");

            await ellipsis.click();
            await page.waitForChanges();

            const currentPage = await el.getProperty("page");
            expect(currentPage).toEqual(20);

            expect(error).not.toHaveBeenCalled();
        });

        error.mockReset();
        error.mockRestore();
    });

    it("should show the mobile input when there's not enough space", async () => {
        const error = jest.spyOn(global.console, "error");
        const page = await newE2EPage({
            html: `<div style="width: 300px"><uic-pagination total-pages="50"></uic-pagination><div>`
        });
        const el = await page.find("uic-pagination");
        await page.waitForChanges();

        expect(error).not.toHaveBeenCalled();
        expect(el).toMatchSnapshot();
    });
});
